export interface BdUiFileInputConfig {
  accept: string;
}

export const BD_UI_FILE_INPUT_CONFIG_DEFAULT: BdUiFileInputConfig = {
  accept: '*',
};
